// Update the global widget state
export interface ClearWidgetFormErrorsAction {
  type: "CLEAR_WIDGET_FORM_ERRORS";
}

export function clearWidgetFormErrors(): ClearWidgetFormErrorsAction {
  return {
    type: "CLEAR_WIDGET_FORM_ERRORS",
  };
}
